import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Tabs } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { Error } from 'components/common';

import MainFieldSet from './MainFieldSet';
import ParametersFieldSet from './ParametersFieldSet';
import ContactFieldSet from './ContactFieldSet';
import ServiceFieldSet from './ServiceFieldSet';
import TariffFieldSet from './TariffFieldSet';
import GeoFieldSet from './GeoFieldSet';


class ProfileForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { actions, profile } = this.props;
        const instance = profile.editObject;

        let data = Object.assign({}, values);
        if (instance && instance.id) {
          data.id = instance.id;
        }
        console.log(data);
        actions.profileUpdate(data);
      }
    });
  };

  close = () => {
    const { actions } = this.props;
    actions.profileShowEditForm({ show: false });
  };

  render() {
    const { form, profile, siteId } = this.props;
    const { showEditForm, updateStatus } = profile;

    const error = updateStatus.error || {};
    const errorData = error.data || {};

    const isLoading = updateStatus.isLoading;

    return (
      <Modal
        width={960}
        visible={showEditForm}
        title="Редактирование анкеты"
        onCancel={this.close}
        maskClosable={false}
        destroyOnClose={true}
        footer={[
          <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
            Сохранить
          </Button>,
        ]}
      >
        <Spin spinning={isLoading}>
          <Form onSubmit={this.handleSubmit}>
            <Error errors={errorData.non_field_errors}/>

            <Tabs className="tabs">
              <Tabs.TabPane tab="Основное" key="detail" forceRender={true}>
                <MainFieldSet profile={profile} siteId={siteId} form={form} onPhotoChange={this.handlePhotosChange}/>

                <GeoFieldSet profile={profile} form={form}/>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Параметры" key="parameters" forceRender={true}>
                <ParametersFieldSet profile={profile} form={form}/>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Контакты" key="contacts" forceRender={true}>
                <ContactFieldSet profile={profile} form={form}/>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Услуги" key="service" forceRender={true}>
                <ServiceFieldSet profile={profile} form={form}/>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Тарифы" key="tariff" forceRender={true}>
                <TariffFieldSet profile={profile} form={form}/>
              </Tabs.TabPane>
            </Tabs>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

const WrappedForm = Form.create()(ProfileForm);

function mapStateToProps(state) {
  return {
    profile: state.profile,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.profile), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedForm);

